@if (subSection) {
  <div class="flex flex-column gap-2 mb-3">
    <div class="mt-1" style="display: grid; grid-template-columns: 1fr 3fr 1fr 3fr 1fr 3fr 1fr; grid-gap: 10px">
      <!--      row1-->
      <div class="flex align-items-center">Nom interne</div>
      <input [(ngModel)]="title_internal" required pInputText (ngModelChange)="checkPendingChangesVersion()" />
      <div class="flex align-items-center">Catégorie</div>
      <app-dropdown-firestore
        [(ngModel)]="category"
        [referentialKey]="Referential.category_subsection"
        [required]="true"
        (ngModelChange)="checkPendingChangesVersion()"
      ></app-dropdown-firestore>
      <div class="flex align-items-center">Programme</div>
      <app-dropdown-firestore
        [(ngModel)]="program"
        [referentialKey]="Referential.program_code"
        [required]="true"
        (ngModelChange)="checkPendingChangesVersion()"
      ></app-dropdown-firestore>
      <p-button
        severity="secondary"
        label="Enregistrer"
        [disabled]="!pendingChangesVersion"
        class="w-full"
        (click)="updateMainSubSection()"
      ></p-button>
    </div>
  </div>

  @if (currentVersion) {
    <div class="flex flex-column gap-2 mb-3 container">
      <div class="mt-1" style="display: grid; grid-template-columns: 8% 25% 8% 25% 8% 25%; grid-row-gap: 10px">
        <div class="flex align-items-center">Versions</div>
        <p-dropdown
          [disabled]="pendingChanges"
          [(ngModel)]="currentVersionId"
          [options]="subSection.versions"
          placeholder="Selectionner une version"
          optionValue="id"
          optionLabel="title"
          [showClear]="true"
          (onChange)="versionChange()"
        >
          <ng-template let-item pTemplate="selectedItem">
            {{ item.title }} <span class="ml-2 text-gray-500">[{{ item.title_internal }}]</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            {{ item.title }} <span class="ml-2 text-white-alpha-50">[{{ item.title_internal }}]</span>
          </ng-template>
        </p-dropdown>
        <!--        <div></div>-->
        @if (currentVersion) {
          <div class="flex align-items-center ml-4">Nom de version</div>
          <input
            [(ngModel)]="currentVersion.title_internal"
            required
            pInputText
            (ngModelChange)="checkPendingChanges()"
          />

          <div class="flex align-items-center ml-4">Nom externe</div>
          <input [(ngModel)]="currentVersion.title" required pInputText (ngModelChange)="checkPendingChanges()" />
        }
      </div>
      <div class="flex align-items-center">
        <p-fileUpload
          mode="basic"
          [auto]="true"
          accept=".mp4,image/*"
          [maxFileSize]="9000000"
          [customUpload]="true"
          (uploadHandler)="onUpload($event)"
          chooseLabel="bg fullpage"
          class="primary"
        />
        @if (currentVersion.backgroundImg) {
          <div><img class="ml-4" style="height: 50px; width: auto" [src]="currentVersion.backgroundImg" /></div>
          <i
            title="Supprimer le mode full page"
            class="cursor-pointer pi pi-trash ml-4 mr-2"
            (click)="deleteBgImage()"
          ></i>
        }
        <div class="flex align-items-center gap-1 ml-6">
          <p-checkbox
            inputId="ny"
            [binary]="true"
            [(ngModel)]="currentVersion.hideTitleSection"
            (ngModelChange)="checkPendingChanges()"
          />
          <label for="ny">Cacher le titre de section</label>
        </div>
        @if (currentVersion.date) {
          <div class="font-italic text-xs text-gray-400 ml-6">
            Page modifée le
            {{ currentVersion.date | date: "dd MMM yyyy 'à' HH:mm:ss" }}
          </div>
        }
      </div>

      <div class="mt-1">
        @if (currentVersion) {
          <app-editor2
            [(ngModel)]="currentVersion.content"
            (ngModelChange)="checkPendingChanges()"
            [storageId]="subSection.id || '??'"
            [style]="{ height: 'calc(98vh - 600px)' }"
          ></app-editor2>
        }
      </div>

      <div class="mt-2 mb-2 flex justify-content-between">
        <p-button
          severity="secondary"
          label="Nouvelle version [vide]"
          (click)="newVersion()"
          [disabled]="pendingChanges"
        ></p-button>
        <p-button
          severity="secondary"
          label="Dupliquer la version"
          [disabled]="pendingChanges"
          (click)="newVersion(false)"
        ></p-button>
        <div
          [style.visibility]="pendingChanges ? 'visible' : 'hidden'"
          class="font-italic text-red-400 justify-content-center flex align-items-center"
        >
          <div class="mr-4">Modifications en cours non enregistrées</div>
          <p-button severity="secondary" label="Annuler les modifications" (click)="cancelChanges()"></p-button>
        </div>

        <p-button label="Enregistrer" (click)="saveVersion()" [disabled]="!pendingChanges"></p-button>
        <p-button label="Enregistrer et quitter" (click)="saveVersion(true)" [disabled]="!pendingChanges"></p-button>
      </div>
    </div>
  }
}
